import React, { useState } from "react";
import { useSelection } from "../SelectionContext";
import { useNodeActions } from "../../hook/useNodeActions";
import { ElementPicker } from "./ElementPicker";
import { usePicker } from "./PickerContext";


export function AddElementZone({ sectionId, containerId, cardId, index, page, setPage  }) {
    const { addElementAction  } = useNodeActions(page, setPage);
  const { setSelectedNodeId } = useSelection();
  const [showPicker, setShowPicker] = useState(false);
 const { activePicker, setActivePicker } = usePicker();
const isActive =
    activePicker &&
    activePicker.sectionId === sectionId &&
    activePicker.containerId === containerId &&
    activePicker.cardId === cardId &&
    activePicker.index === index;

  function togglePicker(e) {
    e.stopPropagation();
    if (isActive) {
      setActivePicker(null);
    } else {
      setActivePicker({ sectionId, containerId, cardId, index });
    }
  }
  function addElementItem(type) {
    const elementDefaults = {
      header: { type: "header", content: "Heading", styleRole: "heading" ,styles: { default: {}, theme: {}, custom: {} } },
      para: { type: "para", content: "Paragraph text", styleRole: "body",styles: { default: {}, theme: {}, custom: {} } },
      btn: { type: "btn", content: "Click Me", styleRole: "button",styles: { default: {}, theme: {}, custom: {} } },
      image: { type: "image", src: "https://via.placeholder.com/200",styles: { default: {}, theme: {}, custom: {} } },
      icon: { type: "icon", content: "★" ,styles: { default: {}, theme: {}, custom: {} }},
      video: { type: "video", src: "https://via.placeholder.com/320" ,styles: { default: {}, theme: {}, custom: {} }},
    };

    const newElement = elementDefaults[type];
 
    const newElId = addElementAction(
      sectionId,
      containerId,
      cardId,
      newElement,
      index
    );
    // console.log(newElId)

    setShowPicker(false);
    setSelectedNodeId(newElId);
  }
  return (
    <div
      style={{
        height: "12px",
        background: "transparent",
        margin: "6px 0",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#1A73E8";
        e.currentTarget.style.height = "18px";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.height = "5px";
      }}
    
      onClick={togglePicker}
    >


         {isActive &&  (
        <div style={{ position: "absolute", top: "16px" }}>
          <ElementPicker onSelect={(type) => {
              addElementItem(type);
              setActivePicker(null);
            }} />
        </div>
      )}
    </div>
  );
}
